<script lang="ts">
  import { debounce } from 'es-toolkit'
  import i18n from '../../../../../i18n'
  import usePrinterQueries from '../../../hooks/usePrinterQueries'
  import Area from './Area.svelte'
  import Grid from './Grid.svelte'
  import { ThreeItemKeys } from '../../../../../constants/three'
  import {
    getPrinterAreaType,
    getPrinterGridType,
  } from '../../../../../helpers/printer'
  import SectionContainer from '../SectionContainer.svelte'
  import { PrinterService } from '../../../../../services'

  const { printerId }: { printerId: string } = $props()

  let areaType = $state('none')
  let gridType = $state('none')

  const { usePrinter, updateAttributeMutation } = usePrinterQueries()
  const printerQuery = $derived(usePrinter(printerId))
  let printer = $derived(printerQuery.data)
  let printerDriver = $derived(
    PrinterService.getPrinterDriver(
      printer?.userData[ThreeItemKeys.PRINTER_MODEL],
    ),
  )

  const onStateUpdate = debounce((props: Record<string, number | string>) => {
    updateAttributeMutation.mutate({ objectUuid: printerId, object: props })
  }, 500)

  $effect(() => {
    onStateUpdate({
      [ThreeItemKeys.AREA_TYPE]: areaType,
      [ThreeItemKeys.GRID_TYPE]: gridType,
    })
  })

  $effect(() => {
    areaType = getPrinterAreaType(printer)
    gridType = getPrinterGridType(printer)
  })
</script>

{#key printerQuery.dataUpdatedAt}
  {#if printer}
    <SectionContainer title={$i18n.t('project.rightBar.zoneSettings.title')}>
      <div class="row">
        <Grid
          bind:gridType
          hideCartesian={!printerDriver.hasCartesianGrid}
          hidePolar={!printerDriver.hasPolarGrid}
        />
        <Area
          bind:areaType
          hideHalf={!printerDriver.hasHalfPrintableZone}
          hideFull={!printerDriver.hasFullPrintableZone}
        />
      </div>
    </SectionContainer>
  {/if}
{/key}

<style lang="scss">
  .row {
    display: flex;
    gap: 0.5rem;
  }
</style>
